import React from 'react';
import Icon from '@material-ui/core/Icon';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';

const Qualities = ({qualities}) => {

    const QualityView = () => {
        try {
            console.log(qualities[0][0])
            return qualities.map((quality, index) => (
                <div id={index} key={index} className="acr-div acr-s-div acr-align-items-center  carecut-2">
                    <div className="acr-1 acr-s-1 acr-mb-10">
                        <Chip style={{width: "100%", justifyContent: 'start'}} variant="outlined" color="secondary" label={quality[1]}
                              avatar={<Avatar ><Icon style={{fontSize: 20}}>{quality[0]}</Icon></Avatar>}/>
                    </div>
                </div>
            ))
        } catch (e) {
            return <>Yayın yok</>
        }
    }
    return <QualityView/>;
}

export default Qualities;
